/* Exact-origin, exact-frame bridge between the private editor and the store cart. */
(() => {
  const section=document.querySelector('[data-cb-pattern-store]');if(!section)return;
  const frame=section.querySelector('iframe');if(!frame)return;
  const service=new URL(frame.src,window.location.href);
  if(service.protocol!=='https:'&&!['127.0.0.1','localhost'].includes(service.hostname))return;
  const nonce=crypto.randomUUID();
  const seen=new Set();let completed=null;
  const lock=fn=>{
    if(!navigator.locks)return Promise.reject(new Error('Please use a browser with secure cart coordination enabled.'));
    return navigator.locks.request('cozybead-pattern-cart',fn);
  };
  const setup=window.CBPatternPreviewReady || Promise.resolve();
  setup.then(()=>{
    const client=new CBCommerceCore.Cart({catalog:window.CBPatternCatalog,
      fetch:window.CBPatternPreviewFetch || window.fetch.bind(window),root:section.dataset.root||'/',
      storage:window.localStorage,lock,preview:Boolean(window.CBPatternPreviewFetch)});
    const init=()=>frame.contentWindow.postMessage({type:'cb:init',nonce,
      paletteVersions:Object.fromEntries(Object.entries(window.CBPatternCatalog.sizes).map(([size,spec])=>[size,spec.palette_version||window.CBPatternCatalog.palette_sha256]))},service.origin);
    frame.addEventListener('load',init);init();
    window.addEventListener('message',async e=>{
      if(e.source!==frame.contentWindow||e.origin!==service.origin)return;
      const m=e.data;
      if(m?.type==='cb:ready'){init();return;}
      if(m?.nonce!==nonce)return;
      if(m.type==='cb:height'){
        if(Number.isFinite(m.height))frame.style.height=Math.min(6000,Math.max(560,m.height))+'px';
        return;
      }
      if(m.type!=='cb:request'||!['quote','add','checkout'].includes(m.kind)||typeof m.requestId!=='string'||m.requestId.length>64||seen.has(m.requestId))return;
      seen.add(m.requestId);if(seen.size>500)seen.delete(seen.values().next().value);
      const reply=(ok,result,error)=>frame.contentWindow.postMessage({type:'cb:response',nonce,requestId:m.requestId,ok,result,error},service.origin);
      try{
        if(m.kind==='quote'){
          const quote=await client.quote(m.projectId,m.materials);
          if(section.dataset.cartEnabled==='false'){
            quote.canAdd=false;quote.cartDisabled=true;
            quote.lines=quote.lines.map(l=>({...l,status:l.available?'Preview only':l.status}));
          }
          reply(true,quote);return;
        }
        if(m.kind==='add'){
          if(section.dataset.cartEnabled==='false')throw new Error('Adding to cart is disabled in this theme preview.');
          const result=await client.add(m.projectId,m.materials,m.quote);
          if(result.complete)completed={projectId:m.projectId,materials:m.materials};
          reply(true,result);
          // Refresh the displayed cart count without assuming a particular theme drawer API.
          const cart=client.lastCart||await client.json('cart.js');
          document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart}}));
          section.querySelector('[data-cart-status]')?.replaceChildren(document.createTextNode(`${cart.item_count} items in your cart`));
          return;
        }
        if(!completed||!await client.verify(completed.projectId,completed.materials))throw new Error('The cart changed. Add or verify all required beads before checkout.');
        reply(true,{ready:true});
        if(window.CBPatternPreviewFetch){window.dispatchEvent(new CustomEvent('cb:preview-checkout'));return;}
        window.location.assign((section.dataset.root||'/')+'checkout');
      }catch(e){reply(false,null,e.message||'The store could not complete this request.');}
    });
  }).catch(()=>{const status=section.querySelector('[data-cart-status]');if(status)status.textContent='The pattern maker could not connect. Please refresh.';});
})();
